export interface ComicItem {
  id: string;
  title: string;
  author: string;
  status: '连载中' | '已完结';
  category: string;
  tags: string[];
  followers: number;
  rating: number;
  chapters: number;
  intro: string;
  cover: string;
}

export const featuredComics: ComicItem[] = [
  {
    id: 'star-orbit',
    title: '星轨物语',
    author: '临渊映画',
    status: '连载中',
    category: '科幻机甲',
    tags: ['星际', '浪漫'],
    followers: 128000,
    rating: 9.4,
    chapters: 186,
    intro: '少女领航员与AI搭档穿越破碎星环，边冒险边收集回忆碎片，适合和漫友一起同看。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20space%20explorer%20girl%20with%20glowing%20teal%20eyes%20standing%20before%20a%20starry%20nebula%20and%20a%20sleek%20spaceship%2C%20dramatic%20cosmic%20lighting%2C%20vibrant%20teal%20and%20coral%20accents%20on%20deep%20dark%20space%20background%2C%20clean%20composition%2C%20polished%20digital%20illustration%2C%20high%20detail&width=520&height=700&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 'fog-detective',
    title: '雾都侦探社',
    author: '白夜画廊',
    status: '连载中',
    category: '悬疑烧脑',
    tags: ['推理', '都市'],
    followers: 96400,
    rating: 9.2,
    chapters: 142,
    intro: '迷雾笼罩的雨夜城市里，一群年轻的侦探追查连环谜案，每个谜底都适合边看边讨论。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20mysterious%20young%20detective%20in%20a%20long%20coat%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20rainy%20city%20at%20night%2C%20warm%20lamp%20glow%20against%20cool%20teal%20mist%2C%20moody%20dramatic%20lighting%2C%20dark%20urban%20background%2C%20clean%20composition%2C%20polished%20digital%20illustration%2C%20high%20detail&width=520&height=700&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 'salted-fish',
    title: '咸鱼修仙记',
    author: '一颗软糖',
    status: '连载中',
    category: '玄幻修仙',
    tags: ['搞笑', '修仙'],
    followers: 152000,
    rating: 9.1,
    chapters: 233,
    intro: '只想躺平的咸鱼少年意外踏上修仙路，全程爆笑，剧情脑洞清奇，适合一起追更吐槽。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20comedy%20cover%20art%20of%20a%20lazy%20young%20cultivator%20boy%20dressed%20in%20robes%20drowsily%20holding%20a%20flying%20sword%20and%20a%20steamed%20fish%2C%20whimsical%20and%20playful%2C%20warm%20amber%20and%20coral%20colors%20on%20dark%20ink%20background%20with%20cute%20clouds%2C%20clean%20composition%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 'midnight-diner',
    title: '深夜食堂·人间味',
    author: '炭火小馆',
    status: '已完结',
    category: '搞笑日常',
    tags: ['美食', '治愈'],
    followers: 87800,
    rating: 9.0,
    chapters: 98,
    intro: '每道家常菜都藏着一个暖心故事，深夜食堂的烟火气，适合和漫友一边看一边想吃。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20cozy%20midnight%20diner%20interior%20with%20steaming%20warm%20noodle%20bowl%20and%20soft%20lantern%20light%2C%20chef%20smiling%20behind%20counter%2C%20warm%20amber%20and%20coral%20tones%20on%20dark%20background%2C%20comforting%20atmosphere%2C%20clean%20composition%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 'swordsman',
    title: '剑客行·少年志',
    author: '墨刃工作室',
    status: '连载中',
    category: '热血冒险',
    tags: ['武侠', '成长'],
    followers: 176000,
    rating: 9.5,
    chapters: 214,
    intro: '山村少年背剑下山闯荡江湖，热血成长一路燃到底，适合和漫友一起追更打call。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20epic%20cover%20art%20of%20a%20determined%20young%20swordsman%20with%20flowing%20hair%20holding%20a%20glowing%20sword%2C%20dramatic%20wind%20and%20petals%2C%20mountain%20cliff%20background%2C%20vibrant%20coral%20and%20amber%20colors%20on%20dark%20background%2C%20dynamic%20heroic%20composition%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 'sweet-note',
    title: '甜心便利贴',
    author: '桃桃星球',
    status: '连载中',
    category: '甜宠恋爱',
    tags: ['校园', '恋爱'],
    followers: 201000,
    rating: 9.3,
    chapters: 167,
    intro: '校门口便利店的甜甜日常，每一张小纸条都是心动证据，适合和漫友一起嗑糖。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20romance%20cover%20art%20of%20a%20blushing%20schoolgirl%20and%20a%20shy%20boy%20sharing%20a%20sticky%20note%20at%20a%20cute%20convenience%20store%2C%20soft%20warm%20coral%20and%20pink%20lighting%2C%20sweet%20playful%20atmosphere%2C%20clean%20composition%2C%20dark%20cozy%20background%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: 'mecha-commander',
    title: '机甲指挥官',
    author: '钢铁之心',
    status: '已完结',
    category: '科幻机甲',
    tags: ['机甲', '战争'],
    followers: 134000,
    rating: 9.1,
    chapters: 201,
    intro: '天才少年驾驶专属机甲守护人类文明，宏大战争场面，适合和漫友一起燃到最后一话。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20cover%20art%20of%20a%20young%20pilot%20inside%20a%20giant%20robot%20cockpit%20facing%20a%20massive%20orange%20sunset%20battle%2C%20mechanical%20armor%20details%2C%20vibrant%20coral%20and%20teal%20glow%2C%20dark%20industrial%20background%2C%20dramatic%20epic%20composition%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 'shanghai-records',
    title: '山海拾遗录',
    author: '古灵精怪社',
    status: '连载中',
    category: '玄幻修仙',
    tags: ['神话', '冒险'],
    followers: 112000,
    rating: 9.0,
    chapters: 178,
    intro: '少年闯入山海经的世界，收集失落神兽与传说碎片，瑰丽想象适合和漫友一起同看。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20fantasy%20cover%20art%20of%20a%20young%20adventurer%20riding%20a%20winged%20mythical%20beast%20above%20misty%20ancient%20mountains%2C%20glowing%20amber%20and%20teal%20magic%20light%2C%20dark%20mystical%20background%2C%20epic%20composition%2C%20clean%20detailed%20rendering%2C%20polished%20digital%20illustration&width=520&height=700&seq=comic-cover-08&orientation=portrait',
  },
];

export interface CategoryItem {
  name: string;
  en: string;
  desc: string;
  count: number;
  icon: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    name: '热血冒险',
    en: 'Action',
    desc: '燃到骨子里的战斗与成长，和漫友一起并肩追更。',
    count: 1286,
    icon: 'ri-sword-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20heroic%20young%20warriors%20drawing%20swords%20in%20a%20dramatic%20battle%20stance%20with%20fiery%20coral%20energy%20waves%2C%20dark%20bg%2C%20dynamic%20epic%20action%20pose%2C%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-01&orientation=landscape',
  },
  {
    name: '甜宠恋爱',
    en: 'Romance',
    desc: '甜甜的恋爱日常，心动的每个瞬间都有人一起嗑。',
    count: 974,
    icon: 'ri-heart-3-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20two%20cute%20young%20couple%20sharing%20an%20umbrella%20under%20warm%20cherry%20blossom%20rain%2C%20soft%20coral%20pink%20glow%2C%20sweet%20romantic%20mood%2C%20dark%20bg%2C%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-02&orientation=landscape',
  },
  {
    name: '悬疑烧脑',
    en: 'Mystery',
    desc: '步步惊心的高能反转，和漫友一起拼凑真相。',
    count: 703,
    icon: 'ri-search-eye-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20a%20silhouette%20detective%20standing%20in%20a%20moody%20foggy%20alley%20with%20teal%20and%20amber%20neon%20lights%2C%20mysterious%20intriguing%20atmosphere%2C%20dark%20bg%2C%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-03&orientation=landscape',
  },
  {
    name: '搞笑日常',
    en: 'Comedy',
    desc: '轻松沙雕的爆笑日常，追更路上笑到停不下来。',
    count: 859,
    icon: 'ri-emotion-happy-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20funny%20illustration%20of%20a%20group%20of%20students%20laughing%20hilariously%20in%20a%20bright%20school%20classroom%2C%20playful%20comic%20energy%2C%20warm%20amber%20and%20coral%20tones%2C%20dark%20bg%2C%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-04&orientation=landscape',
  },
  {
    name: '玄幻修仙',
    en: 'Xianxia',
    desc: '瑰丽神话与修仙世界，一起同看飞升之路。',
    count: 1105,
    icon: 'ri-sparkling-2-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20fantasy%20illustration%20of%20a%20cultivator%20meditating%20on%20floating%20pagoda%20among%20clouds%20with%20glowing%20amber%20spiritual%20energy%2C%20dark%20mystical%20bg%2C%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-05&orientation=landscape',
  },
  {
    name: '科幻机甲',
    en: 'Sci-Fi',
    desc: '浩瀚星海与钢铁机甲，和漫友一起守护宇宙。',
    count: 612,
    icon: 'ri-robot-2-line',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20illustration%20of%20a%20giant%20mecha%20robot%20standing%20under%20a%20vast%20starry%20nebula%20sky%2C%20vibrant%20teal%20and%20coral%20glow%2C%20dark%20cosmic%20bg%2C%20epic%20clean%20composition%2C%20high%20detail%20digital%20painting&width=640&height=400&seq=comic-cate-06&orientation=landscape',
  },
];

export interface TestimonialItem {
  name: string;
  tag: string;
  text: string;
  avatar: string;
}

export const testimonials: TestimonialItem[] = [
  {
    name: '追更猫猫',
    tag: '已同看 230 话',
    text: '之前一个人追更总是忘了进度，现在和室友一起同看，每天到点准时开更，边看边在弹幕吐槽，追更真的不孤单了！',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20cute%20girl%20with%20cat%20ears%20smiling%2C%20warm%20coral%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-01&orientation=squarish',
  },
  {
    name: '盐系少年',
    tag: '一起追更 86 部',
    text: '科幻机甲区真的是我的快乐老家，和同好开了一个同看房间，每天固定时间一起看《机甲指挥官》，氛围感拉满。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20cool%20young%20man%20with%20short%20dark%20hair%2C%20teal%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-02&orientation=squarish',
  },
  {
    name: '奶昔不加糖',
    tag: '同看 3 年',
    text: '实时同步真的绝，大家翻页进度一模一样，谁先看完最后一格都会在群里激动半天。一起追的感觉太好了。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20sweet%20girl%20with%20glasses%20and%20a%20soft%20smile%2C%20warm%20amber%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-03&orientation=squarish',
  },
  {
    name: '熬夜熬成粥',
    tag: '漫友 500+',
    text: '在这里认识了好多志同道合的漫友，悬疑区一起猜凶手、修仙区一起吐槽剧情，追更路上有伴真的不一样。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20tired%20but%20friendly%20young%20man%20yawning%20with%20a%20smile%2C%20coral%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-04&orientation=squarish',
  },
  {
    name: '三月的风',
    tag: '已看完 58 部',
    text: '更新特别及时，每话上线就能第一时间和漫友同步开看，不用自己蹲更新，一起追省心又开心。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20gentle%20woman%20with%20long%20hair%20and%20a%20warm%20smile%2C%20teal%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-05&orientation=squarish',
  },
  {
    name: '橘子汽水',
    tag: '同看天数 365',
    text: '把喜欢的漫画都推荐给了发小，现在每天固定时间一起同看，连上班路上的通勤都在聊剧情。强推！',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20manga%20style%20avatar%20portrait%20of%20a%20vibrant%20young%20girl%20with%20orange%20hair%20and%20excited%20eyes%2C%20amber%20background%2C%20simple%20clean%20stylized%20headshot%2C%20high%20detail%20digital%20illustration&width=160&height=160&seq=comic-avatar-06&orientation=squarish',
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '什么是"同看"？需要怎么开始？',
    a: '同看是178漫画网的核心玩法：创建一个同看房间，邀请漫友加入后，大家翻页进度实时同步，谁看到哪一格一目了然，全程边看边聊，追更不孤单。点开任意热门作品即可创建房间开始同看。',
  },
  {
    q: '"一起追"是什么意思？和普通追更有区别吗？',
    a: '普通追更是自己盯更新，容易忘。一起追是把你和漫友绑定到同一部作品的更新日程，每话上线第一时间同步通知大家，还能约定固定时间一起开看，让追更变成一件有仪式感的事。',
  },
  {
    q: '漫画更新速度如何？会实时同步吗？',
    a: '178漫画网的作品支持实时同步更新，热门连载作品上线后会在同看房间内即时同步，不用刷新等待。你可以在专区里按"最新更新"查看刚上线的作品。',
  },
  {
    q: '同看房间最多能容纳多少人？',
    a: '普通同看房间默认支持多人同时在线，翻页进度与弹幕实时同步，具体人数上限会随房间类型不同而不同。个人推荐先和小伙伴一起创建专属小房间，体验最流畅。',
  },
  {
    q: '是否支持边看边聊天？',
    a: '支持。同看过程中有专属的弹幕与聊天区，可以边看边聊剧情、吐槽人物，也可以只发表情包互动，让阅读过程更有陪伴感。',
  },
  {
    q: '在178漫画网看漫画需要付费吗？',
    a: '平台提供大量可免费同看的热门漫画专区，具体作品是否有收费章节以作品详情页为准。本站只负责漫画的浏览、同看与追更体验，不涉及任何作品版权授权。',
  },
];

export interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

export const coreFeatures: FeatureItem[] = [
  {
    icon: 'ri-team-line',
    title: '同看',
    desc: '创建同看房间，翻页进度全员实时同步，谁看哪一格都一清二楚，一起感受同频追漫的快乐。',
  },
  {
    icon: 'ri-fire-line',
    title: '一起追',
    desc: '把漫友绑定到作品更新日程，每话上线同步提醒，约定时间一起开看，追更从孤单变热闹。',
  },
  {
    icon: 'ri-broadcast-line',
    title: '实时同步',
    desc: '热门作品实时同步更新，新一话上线即刻在同看房间内推送，边看边聊，永不错过精彩。',
  },
];